:host {
  display: block;
  margin-top: 4px;
}

svg {
  .cls-1 {
    fill: none;
  }

  .cls-2 {
    clip-path: url("#clip-path");
  }

  .cls-3 {
    fill: #5e6a71;
  }

  .cls-4 {
    fill: #066778;
  }

  .cls-5 {
    fill: #830051;
  }
}
